import { StylepacksState } from './types';

export const initialState: StylepacksState = {
  stylepacks: undefined,
  loadingStylepacks: false,
  errorLoadingStylepacks: false,
  stylepackContent: [],
  stylepackAudio: {},
};
